import { Component, Input, OnInit } from '@angular/core';
import {
  IconModule,
  IconSize,
  IconThemeColor,
} from '@progress/kendo-angular-icons';
import { BehaviorSubject } from 'rxjs';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-tcc-spinner',
  standalone: true,
  imports: [IconModule],
  templateUrl: './tcc-spinner.component.html',
  styleUrls: ['./tcc-spinner.component.css'],
})
export class TccSpinnerComponent implements OnInit {
  @Input() size: IconSize = 'xlarge';
  @Input() themeColor: IconThemeColor = 'inherit';

  public isLoading = new BehaviorSubject(false);
  public loading?: boolean;
  constructor(private spinnerService: SpinnerService) {
    this.spinnerService.isLoading.subscribe({
      next: (isLoading) => {
        this.loading = isLoading;
      },
    });
  }

  ngOnInit(): void {}
}
